import { UseFormReturn } from "react-hook-form";
import { Form } from "@themes/pollinator/ui/Form";
import { FormField } from "@themes/pollinator/ui/FormField";
import { AuthPasswordRequirementsContainer } from "@themes/pollinator/ui/AuthPasswordRequirements";

export type ResetPasswordFormData = {
  password: string;
  confirmPassword: string;
};

export type Props = {
  /** Form instance from useForm */
  form: UseFormReturn<ResetPasswordFormData>;
};

/**
 * Reset password form component that renders password fields.
 * This is a presentational component - business logic should be in the container.
 */
export function ResetPasswordForm({ form }: Props) {
  return (
    <Form
      form={form}
      className="w-full"
      innerClassName="justify-center"
      errorContainerClassName="p-0 mt-8"
    >
      <FormField
        name="password"
        label="Password"
        component="Input"
        type="password"
        placeholder="Enter your new password"
        autoComplete="new-password"
        required
        isHideErrorMessage
      />
      <FormField
        name="confirmPassword"
        label="Confirm Password"
        component="Input"
        type="password"
        placeholder="Confirm your new password"
        autoComplete="new-password"
        required
      />
      <AuthPasswordRequirementsContainer />
    </Form>
  );
}

export default ResetPasswordForm;

